__turbopack_context__.v({
  "centred": "AppHandoffModal-module__GhQtxG__centred",
});
